export default __webpack_public_path__ + "static/media/connect-to-vpn.a7cf72f3.jpg";